import React from "react";
import Airtable from "./components/elements/Airtable";
import Blockquote from "./components/elements/Blockquote";
import CustomButton from "./components/elements/CustomButton";
import Divider from "./components/elements/Divider";
import { HeaderOne, HeaderTwo, HeaderThree, HeaderFour } from "./components/elements/Headers";
import GoogleForms from "./components/elements/GoogleForms";
import GoogleSpreadsheet from "./components/elements/GoogleSpreadsheet";
import GovlaunchProject from "./components/elements/GovlaunchProject";
import Image from "./components/elements/Image";
import Link from "./components/elements/Link";
import Paragraph from "./components/elements/Paragraph";
import Typeform from "./components/elements/Typeform";
import YoutubeVideoElement from "./components/elements/YoutubeVideoElement";
import Simplecast from "./components/elements/Simplecast";
import SocialMedias from "./components/elements/SocialMedias";
import UnorderedListItem from "./components/elements/UnorderedListItem";
import SubscribeEmbed from "./components/elements/SubscribeEmbed";

export const ELEMENT_PARAGRAPH = "paragraph";
export const ELEMENT_BLOCK_QUOTE = "block-quote";
export const ELEMENT_CODE = "code";
export const ELEMENT_BULLETED_LIST = "bulleted-list";
export const ELEMENT_HEADING_ONE = "heading-one";
export const ELEMENT_HEADING_TWO = "heading-two";
export const ELEMENT_HEADING_THREE = "heading-three";
export const ELEMENT_HEADING_FOUR = "heading-four";
export const ELEMENT_LIST_ITEM = "list-item";
export const ELEMENT_NUMBERED_LIST = "numbered-list";
export const ELEMENT_LINK = "link";
export const ELEMENT_IMAGE = "image";
export const ELEMENT_CUSTOM_BUTTON = "custom-button";
export const ELEMENT_GOVLAUNCH_PROJECT = "govlaunch-project";
export const ELEMENT_YOUTUBE_VIDEO = "youtube-video";
export const ELEMENT_DIVIDER = "divider";
export const ELEMENT_AIRTABLE = "airtable";
export const ELEMENT_GOOGLE_SPREADSHEET = "google-spreadsheet";
export const ELEMENT_TYPEFORM = "typeform";
export const ELEMENT_GOOGLE_FORMS = "google-forms";
export const ELEMENT_SIMPLECAST = "simplecast";
export const ELEMENT_SOCIAL_MEDIAS = "social-medias";
export const ELEMENT_SUBSCRIBE_BUTTON = "subscribe-button";

export const EMPTY_CHILDREN = {
  children: [
    {
      text: "",
    },
  ],
};

export function getNewParagraph() {
  return {
    type: ELEMENT_PARAGRAPH,
    children: [
      {
        text: "",
      },
    ],
  };
}

export default function Element(props) {
  const { attributes, children, element } = props;
  const style = {
    textAlign: element.align,
    fontFamily: "proxima-nova, Helvetica, Arial, sans-serif",
  };

  switch (element.type) {
    case ELEMENT_BLOCK_QUOTE:
      return (
        <Blockquote attributes={attributes} style={style}>
          {children}
        </Blockquote>
      );
    case ELEMENT_CODE:
      return (
        <pre>
          <code {...attributes}>{children}</code>
        </pre>
      );
    case ELEMENT_BULLETED_LIST:
      return (
        <ul
          style={{
            paddingLeft: "20px",
            ...style,
          }}
          {...attributes}
        >
          {children}
        </ul>
      );
    case ELEMENT_HEADING_ONE:
      return (
        <HeaderOne style={style} {...attributes}>
          {children}
        </HeaderOne>
      );
    case ELEMENT_HEADING_TWO:
      return (
        <HeaderTwo style={style} {...attributes}>
          {children}
        </HeaderTwo>
      );
    case ELEMENT_HEADING_THREE:
      return (
        <HeaderThree style={style} {...attributes}>
          {children}
        </HeaderThree>
      );
    case ELEMENT_HEADING_FOUR:
      return (
        <HeaderFour style={style} {...attributes}>
          {children}
        </HeaderFour>
      );
    case ELEMENT_LIST_ITEM:
      return (
        <UnorderedListItem style={style} {...attributes}>
          {children}
        </UnorderedListItem>
      );
    case ELEMENT_NUMBERED_LIST:
      return (
        <ol
          style={{
            paddingLeft: "20px",
            ...style,
          }}
          {...attributes}
        >
          {children}
        </ol>
      );
    case ELEMENT_LINK:
      return (
        <Link element={element} {...attributes} style={style}>
          {children}
        </Link>
      );
    case ELEMENT_IMAGE:
      return (
        <Image
          {...{
            attributes,
            children,
            element,
            style,
          }}
        />
      );
    case ELEMENT_YOUTUBE_VIDEO:
      return (
        <YoutubeVideoElement
          {...{
            attributes,
            children,
            element,
          }}
        />
      );
    case ELEMENT_DIVIDER:
      return (
        <Divider
          {...{
            attributes,
            children,
            element,
          }}
        />
      );
    case ELEMENT_AIRTABLE:
      return (
        <Airtable
          {...{
            attributes,
            children,
            element,
          }}
        />
      );
    case ELEMENT_GOOGLE_SPREADSHEET:
      return (
        <GoogleSpreadsheet
          {...{
            attributes,
            children,
            element,
          }}
        />
      );
    case ELEMENT_GOOGLE_FORMS:
      return (
        <GoogleForms
          {...{
            attributes,
            children,
            element,
          }}
        />
      );
    case ELEMENT_TYPEFORM:
      return (
        <Typeform
          {...{
            attributes,
            children,
            element,
          }}
        />
      );
    case ELEMENT_SIMPLECAST:
      return (
        <Simplecast
          {...{
            attributes,
            children,
            element,
          }}
        />
      );
    case ELEMENT_SOCIAL_MEDIAS:
      return (
        <SocialMedias
          {...{
            attributes,
            children,
            element,
          }}
        />
      );
    case ELEMENT_CUSTOM_BUTTON:
      return (
        <CustomButton
          {...{
            attributes,
            children,
            element,
          }}
        />
      );
    case ELEMENT_GOVLAUNCH_PROJECT:
      return (
        <GovlaunchProject
          {...{
            attributes,
            children,
            element,
          }}
        />
      );
    case ELEMENT_SUBSCRIBE_BUTTON:
      return (
        <SubscribeEmbed
          {...{
            attributes,
            children,
            element,
          }}
          onEmailSubscribe={props.onEmailSubscribe}
        />
      );
    default:
      return (
        <Paragraph style={style} {...attributes}>
          {children}
        </Paragraph>
      );
  }
}
